import React from "react";
import { object, func, bool } from "prop-types";
import { CommunicationPreferences } from "../../../molecules/communication-preferences";
import { PasswordUpdate } from "../../../molecules/password-update";
import { NOTIFICATION_PREFERENCES } from "../../../../constants";

export const ProfileTab = ({
  communicationPreference,
  onPreferenceChange,
  onPreferenceSave,
  onPasswordReset,
  showResetPasswordModal,
  onResetPasswordModalOpen,
  onResetPasswordModalClose,
}) => {
  return (
    <>
      {/* Communication Preferences */}
      <CommunicationPreferences
        selectedPreference={communicationPreference}
        onPreferenceChange={onPreferenceChange}
        onSave={onPreferenceSave}
        preferences={NOTIFICATION_PREFERENCES}
      />

      {/* Password Update */}
      <PasswordUpdate
        onResetPassword={onPasswordReset}
        isModalOpen={showResetPasswordModal}
        onModalOpen={onResetPasswordModalOpen}
        onModalClose={onResetPasswordModalClose}
      />

    </>
  );
};

ProfileTab.propTypes = {
  communicationPreference: object,
  onPreferenceChange: func.isRequired,
  onPreferenceSave: func.isRequired,
  onPasswordReset: func.isRequired,
  showResetPasswordModal: bool.isRequired,
  onResetPasswordModalOpen: func.isRequired,
  onResetPasswordModalClose: func.isRequired,
  clientManagerData: object
};